import { useContext } from 'react';
import { NavigationLoaderContext } from '../context/navigationLoader.context';

export function useNavigationLoader() {
  const context = useContext(NavigationLoaderContext);
  if (!context) {
    throw new Error('useNavigationLoader must be used within NavigationLoaderProvider');
  }
  return context;
}
